import { render, staticRenderFns } from "./FilePreviewer.vue?vue&type=template&id=39047414"
import script from "./FilePreviewer.vue?vue&type=script&lang=js"
export * from "./FilePreviewer.vue?vue&type=script&lang=js"
import style0 from "./FilePreviewer.vue?vue&type=style&index=0&id=39047414&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports